(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const cartForm = document.querySelector('form[action="/cart"]');
    const checkoutButton = document.querySelector('#checkout');
    const employerInput = document.querySelector('#Cart-fec-employer');
    const occupationInput = document.querySelector('#Cart-fec-occupation');
    const agreementCheckbox = document.querySelector('#Cart-fec-agreement');
    const cartErrors = document.querySelector('#cart-errors');

    if (!cartForm) {
      return;
    }

    function showError(message) {
      if (cartErrors) {
        cartErrors.innerHTML = `
          <div class="cart-errors" role="alert" style="
            background-color: rgba(255, 0, 0, 0.1);
            border: 1px solid rgba(255, 0, 0, 0.3);
            border-radius: 0.5rem;
            padding: 1.5rem;
            margin-top: 1rem;
            color: rgb(var(--color-foreground));
            font-size: 1.4rem;
          ">
            <strong>Error:</strong> ${message}
          </div>
        `;
        cartErrors.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function clearError() {
      if (cartErrors) {
        cartErrors.innerHTML = '';
      }
    }

    function validateFecCompliance(event) {
      clearError();

      // Only validate if FEC fields exist
      if (!employerInput || !occupationInput || !agreementCheckbox) {
        return true;
      }

      const employer = employerInput.value.trim();
      const occupation = occupationInput.value.trim();
      const isAgreed = agreementCheckbox.checked;

      if (!employer) {
        event.preventDefault();
        showError('Please enter your employer.');
        employerInput.focus();
        return false;
      }

      if (!occupation) {
        event.preventDefault();
        showError('Please enter your occupation.');
        occupationInput.focus();
        return false;
      }

      if (!isAgreed) {
        event.preventDefault();
        showError('Please confirm that you have read and agree to the statements above.');
        agreementCheckbox.focus();
        return false;
      }

      return true;
    }

    // Attach validation to form submit event (catches all submission methods)
    cartForm.addEventListener('submit', function(event) {
      validateFecCompliance(event);
    });

    // Clear errors when user starts typing/checking
    if (employerInput) {
      employerInput.addEventListener('input', clearError);
    }
    if (occupationInput) {
      occupationInput.addEventListener('input', clearError);
    }
    if (agreementCheckbox) {
      agreementCheckbox.addEventListener('change', clearError);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
